<template>
<svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M12.8848 5.29541V19.2954" fill="#773DBD" stroke="#773DBD" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M5.88477 12.2954H19.8848" fill="#773DBD" stroke="#773DBD" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
</template>
